










































































import { Vue, Component, Mixins, Prop } from "vue-property-decorator";

import MyForm from "@/mixins/form";

import TsUpload from "@/components/upload.vue";

@Component({
  components: {
    TsUpload
  }
})
export default class extends Mixins(MyForm) {
  @Prop() optionId!: number;

  @Prop() itemTypes!: any[];

  itemType = "1";

  selectItemType(val: string) {
    this.itemType = val;
  }

  handleSubmit() {
    this.form.validateFields((err: any, values: any) => {
      if (!err) {
        this.$confirm({
          title: "确认信息",
          content: "你确定要提交吗？",
          onOk: async () => {
            this.confirmLoading = true;
            const res = await this.$store.dispatch("options/additem", {
              option_id: this.optionId,
              ...values
            });
            if (res && res.Message && res.Message === "success") {
              this.$message.success(res.Message);
              this.handleCancel();
            } else {
              this.$message.error(res.Message);
            }
            this.confirmLoading = false;
          }
        });
      }
    });
  }
}
